import { Box, Typography } from "@mui/material";

export default function ProjectTemplateCard({ logo, title, description }) {
    return (
        <Box
            sx={{
                display: "flex",
            }}
        >
            <Box display="flex" alignContent="center" justifyItems="center">
                <Box sx={{ paddingX: 4 }}>{logo}</Box>
            </Box>
            <Box sx={{ marginLeft: 2 }}>
                <Typography variant="h1" fontSize={20} fontWeight="bold" color="primary" gutterBottom>
                    {title}
                </Typography>
                <Typography variant="subtitle1">{description}</Typography>
            </Box>
        </Box>
    );
}
